<section *ngIf="entryModalConfigurableData">
  <p-dialog
    [(visible)]="displayModal"
    modal="modal"
    [draggable]="false"
    responsive="true"
    appendTo="body"
    [closeOnEscape]="true"
    (onHide)="closeEntryModal()"
  >
    <tmo-spinner [setDelay]="!isLoading"></tmo-spinner>
    <p-header>
      <div class="modal-logo-close">
        <i class="logo-icon t-icon t-icon-logo"></i>
      </div>
      <h3 *ngIf="billingType === entryModalConstants?.PREPAID; else postPaidHeader">
        {{ entryModalConfigurableData?.enterZipCode }}
      </h3>
      <ng-template #postPaidHeader>
        <h3>{{ entryModalConfigurableData?.enterCreditPlan }}</h3>
      </ng-template>
    </p-header>
    <tmo-form
      *ngIf="!entryModalForm.pristine"
      formName="EntryModalComponent#ZipCodeForm"
      pdlPageComponentId="EntryModalFormComponent"
    ></tmo-form>
    <form [formGroup]="entryModalForm">
      <tmo-zip-code-validation
        *ngIf="displayModal"
        [zipCodeConfigurableData]="entryModalConfigurableData"
        (formChange)="zipCodeChanged($event)"
        [zipCodeValidationForm]="entryModalForm.controls.zipCodeValidationForm"
      ></tmo-zip-code-validation>
      <!--<div [hidden]="billingType === entryModalConstants?.PREPAID">-->
      <div [hidden]="true">
        <tmo-plan-type
          [planTypeConfigurableData]="entryModalConfigurableData"
          [billingType]="billingType"
          [planType]="selectedPlanType"
          (onPlanSelect)="planTypeChanged($event)"
        ></tmo-plan-type>
      </div>
      <div *ngIf="showCreditStatus">
        <tmo-credit
          [creditConfigurableData]="entryModalConfigurableData"
          (onCreditSelect)="creditLevelChanged($event)"
        ></tmo-credit>
      </div>
      <p-footer>
        <div *ngIf="billingType === entryModalConstants?.PREPAID; else postPaidCta">
          <div class="row">
            <div class="col-12 buttons-container button-spacing">
              <div class="button-box">
                <tmo-button
                  [button]="continueButton"
                  (onSelect)="handleSubmit($event)"
                  tmoFormPdl="EntryModalComponent#ZipCodeForm"
                  [disabled]="
                    !entryModalForm?.controls['zipCodeValidationForm']?.valid ||
                    !selectedAddress?.addressid
                  "
                  >{{ entryModalConfigurableData?.continue }}</tmo-button
                >
              </div>
            </div>
          </div>
        </div>
        <ng-template #postPaidCta>
          <div class="row">
            <div class="col-12 buttons-container button-spacing">
              <!-- <div class="button-box" *ngIf="isAssistedChannel">
                          <button class="btn btn-secondary" (click)="setPreviousRoute()" [routerLink] = "['/credit-check/communications']" [disabled]="!showCreditStatus" id="btn-default-203">{{entryModalConfigurableData?.runCreditCheck}}</button>
                        </div> -->
              <div class="button-box">
                <button
                  class="btn btn-primary"
                  tmoFormPdl="EntryModalComponent#ZipCodeForm"
                  name="Continue"
                  (click)="handleSubmit($event)"
                  [disabled]="
                    !entryModalForm.controls['zipCodeValidationForm'].valid ||
                    (entryModalForm.controls['zipCodeValidationForm'].valid && !changedZipCode)
                  "
                  id="btn-continue-2"
                >
                  {{ entryModalConfigurableData?.acceptAndSubmit }}
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </p-footer>
    </form>
  </p-dialog>
  <tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
</section>
